export default __webpack_public_path__ + "static/media/sch8.9dd31cd1.jpg";